class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);
// ===============================
// Blessed Journey Discount Logic
// ===============================

// Run on quantity button click
document.addEventListener('click', function (e) {
  if (
    e.target.closest('[data-plus-quantity-cart]') ||
    e.target.closest('[data-minus-quantity-cart]')
  ) {
    setTimeout(updateBJMessages, 400);
  }
});

// Run on initial load
document.addEventListener('DOMContentLoaded', () => {
  updateBJMessages();

  const cartContainer = document.querySelector('.previewCart');

  if (cartContainer) {
    cartObserver.observe(cartContainer, {
      childList: true,
      subtree: true,
    });
  }
});

// Optimized observer (debounced)
let timeout;

const cartObserver = new MutationObserver(() => {
  clearTimeout(timeout);
  timeout = setTimeout(updateBJMessages, 200);
});

// Main function
function updateBJMessages() {
  document.querySelectorAll('.previewCartItem').forEach((item) => {
    const vendor = item.dataset.vendor;
    const qtyInput = item.querySelector('[data-cart-quantity]');
    const message = item.querySelector('.bj-item-message');

    if (!vendor || !qtyInput || !message) return;

    const qty = parseInt(qtyInput.value);

    if (vendor === 'blessed journey') {
      let discount = 10;

      const title = item
        .querySelector('.previewCartItem-name .text')
        ?.innerText.toLowerCase();

      if (!title) return;

      if (title.includes('spearmint')) discount = 35;
      else if (title.includes('lemon balm')) discount = 30;
      else if (title.includes('hibiscus')) discount = 15;
      else if (title.includes('calendula') || title.includes('peppermint'))
        discount = 10;

      if (qty === 1) {
        message.innerText = `Add 1 more to unlock ${discount}% OFF 🎯`;
        message.classList.remove('success');
      } else if (qty >= 2) {
        message.innerText = `${discount}% OFF unlocked 🎉`;
        message.classList.add('success');
      }
    }
  });
}
// force run after everything loads
window.addEventListener('load', () => {
  setTimeout(updateBJMessages, 500);
});
// run after any cart update (AJAX safe)
document.addEventListener('DOMContentLoaded', () => {
  setInterval(updateBJMessages, 1000);
});